import React, { lazy } from 'react'
import { useSelector } from 'react-redux'
import { List } from 'immutable'
import PropTypes from 'prop-types'
import { hasContentHighlightsAccess } from '../../services/content-highlights/access'
import { ERROR_TYPE_404 } from '../ErrorPage/types'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'

const LoadableContentHighlightsPage = lazy(
  () => import('./index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

const LoadableErrorPage = lazy(
  () => import('../ErrorPage/index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

/**
 * Access gate for /highlights. Mounted as JSX from routes (not invoked as a bare
 * route function) so hooks stay on this component's fiber — same pattern as SearchPageSwitch.
 */
export default function ContentHighlightsRouteGate ({ history, location }) {
  const auth = useSelector((state) => state.auth)
  const roleIds = auth ? auth.get('roleIds', List()) : List()
  const subscriptions = auth ? auth.get('subscriptions', List()) : List()
  if (!hasContentHighlightsAccess({ roleIds, subscriptions })) {
    return (
      <LoadableErrorPage
        history={history}
        location={location}
        code={ERROR_TYPE_404}
      />
    )
  }
  return <LoadableContentHighlightsPage location={location} history={history} />
}

ContentHighlightsRouteGate.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}
